import { useEffect, useRef, useState } from "react";
import { instanceMob } from "../../../../utils/utils";
import ConfirmDeletionModal from "../modal-delete";
import "../../styles.css";
import * as bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const data = [
  { id: 1, name: "Últimos 7 días", valor: "l7" },
  { id: 2, name: "Último mes", valor: "l30" },
  { id: 3, name: "Últimos 3 meses", valor: "l90" },
  { id: 4, name: "Último Año", valor: "l365" },
];

const PanelLeftAdministrativeSuspensions = (props) => {
  const [frecuency, setFrecuency] = useState("l7");
  const [dataRes, setDataRes] = useState("000");
  const [modalError, setModalError] = useState(null);

  const selectedOption = data.find((d) => d.valor === frecuency);
  const dropdownRef = useRef(null);
  const dropdownInstanceRef = useRef(null);

  function queryRes(frecuency) {
    instanceMob
      .get(`/admin/metrics/customer-plan?date_range=${frecuency}`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setDataRes(res.data.left);
        }
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          setModalError(
            <ConfirmDeletionModal
              onCancel={() => setModalError(null)}
              onConfirm={() => setModalError(null)}
              loader={false}
            >
              Algo sucedio, inteenta de nuevo
            </ConfirmDeletionModal>
          );
        }
      });
  }

  useEffect(() => {
    queryRes(frecuency);
  }, [frecuency]);

  useEffect(() => {
    if (dropdownRef.current) {
      dropdownInstanceRef.current = new bootstrap.Dropdown(dropdownRef.current);
    }
  }, []);

  const handleToggleDropdown = (e) => {
    e.preventDefault();
    if (dropdownInstanceRef.current) {
      dropdownInstanceRef.current.toggle();
    }
  };

  return (
    <>
      <div
        style={{
          width: "50%",
          border: "1px solid #B6C1CE",
          borderRadius: "10px",
          height: "100%",
        }}
        className="PanelLeftAdministrativeSuspensions"
      >
        <div className="h-100 d-flex flex-column align-items-center gap-2 p-2">
          <span className="card-title">Suspensiones</span>

          <div className="dropdown w-100 text-center position-relative">
            <button
              ref={dropdownRef}
              className="btn dropdown-toggle w-100 card-select d-flex justify-content-between align-items-center"
              type="button"
              id="customDropdown1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={handleToggleDropdown}
            >
              <span>{selectedOption?.name || "Selecciona"}</span>
              <span
                dangerouslySetInnerHTML={{
                  __html: `<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.26912 8.89571C6.91484 8.89571 6.56051 8.76057 6.29014 8.49022L0.925015 3.12509C0.38437 2.58444 0.38437 1.70785 0.925015 1.16719C1.46564 0.62656 2.34226 0.62656 2.88289 1.16719L7.26912 5.55347L11.6553 1.16719C12.196 0.62656 13.0726 0.62656 13.6132 1.16719C14.1539 1.70785 14.1539 2.58444 13.6132 3.12509L8.2481 8.49022C7.97775 8.76057 7.6234 8.89571 7.26912 8.89571Z" fill="#9DACBD"/></svg>`,
                }}
              />
            </button>
            <ul
              className="dropdown-menu w-100 card-select-menu p-2"
              aria-labelledby="customDropdown1"
            >
              {data.map((item) => (
                <li
                  key={item.id}
                  className={`card-select-label dropdown-item ${
                    frecuency === item.valor ? "active" : ""
                  }`}
                  onClick={() => setFrecuency(item.valor)}
                  style={{ cursor: "pointer" }}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          </div>

          <span className="card-value">{dataRes}</span>
        </div>
      </div>
      {modalError}
    </>
  );
};
export default PanelLeftAdministrativeSuspensions;
